import { useState } from "react";
import { Alert, Button, Pagination, Skeleton, TextField } from "@mui/material";
import DataFetcher from "../../../../shared/api";
import { baseUrl, DOWNLOAD_FILE, GET_ALL_GALLERY } from "../../../../shared/api/endpoints";
const order = { id: false }, filters = [{ name: "hidden", value: false, type: "eq" }];

/** The chooser is bounded and paged; it never mounts the full gallery manager. */
export default function GallerySelection({ setSelceted }) {
  const [page, setPage] = useState(1), [query, setQuery] = useState(""), [search, setSearch] = useState("");
  const { allData, loading, errors, metaData } = DataFetcher(24, page, order, GET_ALL_GALLERY, filters, true, 0, search, 2);
  function applySearch() { setPage(1); setSearch(query.trim()); }
  return <section className="flex flex-col gap-3" aria-label="انتخاب تصویر از گالری">
    <div className="flex gap-2 items-center">
      <TextField fullWidth size="small" label="جستجوی تصویر" value={query}
        onChange={(event) => setQuery(event.target.value)} onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); applySearch(); } }} />
      <Button type="button" onClick={applySearch} disabled={loading}>جستجو</Button>
    </div>
    {errors && <Alert severity="error">دریافت تصاویر انجام نشد.</Alert>}
    <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 gap-3 overflow-y-auto" style={{ maxHeight: "55vh", minHeight: 260 }}>
      {loading ? Array.from({ length: 12 }, (_, index) => <li key={index}><Skeleton variant="rounded" height={126} /></li>) :
        allData.filter((item) => item.hidden !== true).map((item) => <li key={item.id}>
          <button type="button" data-gallery-id={item.id} className="w-full border rounded p-1 text-right" aria-label={`انتخاب ${item.originalFileName || item.id}`}
            onClick={() => setSelceted(item.id)}>
            <img src={`${baseUrl}/${DOWNLOAD_FILE}/${item.id}?size=small`} alt={item.alt || item.originalFileName || "تصویر"}
              loading="lazy" decoding="async" className="w-full object-contain" style={{ height: 96 }} />
            <span className="block truncate text-xs mt-1" title={item.originalFileName}>{item.originalFileName || item.id}</span>
          </button>
        </li>)}
    </ul>
    {!loading && !errors && !allData.length && <p role="status">تصویری پیدا نشد.</p>}
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <span className="text-xs">تعداد نتایج: {metaData?.total ?? "—"} · حداکثر ۲۴ تصویر در هر صفحه</span>
      <Pagination page={page} count={metaData?.total_pages || 1} disabled={loading} onChange={(event, value) => setPage(value)} />
    </div>
  </section>;
}
